import { Link } from "react-router-dom";
import React from "react";

const Footer = () => {
  // const [text, setText] = useState("Privacy Policy |");
  // useEffect(() => {
  //   if (window.location.href.includes("/forgotPassword") || window.location.href.includes("/forgotPassword") ) {
  //     setText("");
  //   }
  //   console.log(window.location.href);
  // }, []);

  const year = new Date().getFullYear();
  return (
    <div className="bg-comgBg flex w-[100%] justify-center py-2">
      <div
        className="md:flex text-center flex-row justify-center text-grayish text-xs font-semibold w-[100%]"
        data-testid="footer">
        <div>
          <Link to={"/privacy-policy"} target={"_blank"}>
            Privacy Policy
          </Link>
          <span className="px-2">|</span>
          <span>© FeedAnts</span>
          <span className="px-2">|</span>
          <Link to={"/about"} target={"_blank"}>
            About Us
          </Link>
          <span className="px-2">|</span>
          <Link to={"/about"} target={"_blank"}>
            Contact Us
          </Link>
          <span className="px-2">|</span>
          <span>BlaccSckull Platforms Private Limited {year}</span>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Footer);
